export const PERSONALIZE_EXPERIENCES = 'personalizeExperiences';
export const CAPTURE_CONVERT_LEADS_CMS = 'captureAndConvertLeadsCms'; // Marketing Biz Objectives

export const ATTRACT_AUDIENCE_ATTENTION = 'attractAudienceAttention';
export const UNDERSTAND_LEADS = 'understandYourLeads';
export const AUTOMATE_MARKETING = 'automateAndPersonalizeYourMarketing';
export const GET_FOUND_ONLINE_MARKETING = 'getFoundOnlineMarketing';
export const OPTIMIZE_CONVERSION = 'optimizeConversionRates';
export const BUILD_CUSTOM_REPORTS = 'buildCustomReports';
export const BUILD_CUSTOM_REPORTS_MON607 = 'buildCustomReportsMON607';
export const MANAGE_TEAMS_AND_BRANDS = 'manageYourTeamsAndBrands';
export const MANAGE_TEAMS_AND_BRANDS_MON607 = 'manageYourTeamsAndBrandsMON607';
export const EXTEND_PLATFORM = 'extendPlatform';
export const EXTEND_PLATFORM_MON607 = 'extendPlatformMON607';
export const ADVANCE_YOUR_REPORTING = 'advanceYourReporting';
export const ADVANCE_YOUR_REPORTING_MON607 = 'advanceYourReportingMON607';
export const AUTOMATE_AND_PERSONALIZE_ENGAGEMENT = 'automateAndPersonalizeYourEngagement';
export const AUTOMATE_AND_PERSONALIZE_ENGAGEMENT_MON607 = 'automateAndPersonalizeYourEngagementMON607';
export const ORCHESTRATE_EFFICIENT_CAMPAIGNS = 'orchestrateEfficientCampaigns';
export const ORCHESTRATE_EFFICIENT_CAMPAIGNS_MON607 = 'orchestrateEfficientCampaignsMON607';
export const OPTIMIZE_CAMPAIGN_CONVERSION = 'optimizeCampaignConversion';
export const REMOVE_BRANDING_MARKETING = 'removeBrandingMarketing';
export const REMOVE_BRANDING_MARKETING_MON607 = 'removeBrandingMarketingMON607';
export const MARKETING_AUTOMATION = 'marketingAutomation'; // Sales Biz Objectives

export const ORGANIZE_YOUR_SALES_PROCESS = 'organizeYourSalesProcess';
export const ORGANIZE_YOUR_SALES_PROCESS_MON607 = 'organizeYourSalesProcessMON607';
export const CONNECT_WITH_PROSPECTS = 'connectWithProspects';
export const TRACK_ITERATE_IMPROVE = 'trackIterateAndImprove';
export const PERSONALIZE_OUTREACH = 'personalizeYourOutreach';
export const PERSONALIZE_OUTREACH_MON607 = 'personalizeYourOutreachMON607';
export const COACH_AND_ENABLE = 'coachAndEnableAtScale';
export const COACH_AND_ENABLE_MON607 = 'coachAndEnableAtScaleMON607';
export const MANAGE_GROWING_TEAM = 'manageYourGrowingTeam';
export const MANAGE_GROWING_TEAM_MON607 = 'manageYourGrowingTeamMON607';
export const CONFIGURE_PRICE_QUOTE = 'configurePriceQuote';
export const CONFIGURE_PRICE_QUOTE_MON607 = 'configurePriceQuoteMON607';
export const SCALE_YOUR_BUSINESS = 'scaleYourBusiness';
export const SUPERCHARGE_YOUR_PIPELINE = 'superChargeYourPipeline';
export const CUSTOMIZE_TO_MATCH_YOUR_BUSINESS = 'customizeToMatchYourBusiness';
export const CUSTOMIZE_TO_MATCH_YOUR_BUSINESS_MON607 = 'customizeToMatchYourBusinessMON607';
export const EXTEND_ADMINISTRATIVE_CONTROLS = 'extendAdministrativeControls';
export const EXTEND_ADMINISTRATIVE_CONTROLS_MON607 = 'extendAdministrativeControls';
export const OPERATE_WITH_EASE_SALES = 'operateWithEaseSales';
export const OPERATE_WITH_EASE_SALES_MON607 = 'operateWithEaseSalesMON607';
export const REMOVE_BRANDING_SALES = 'removeBrandingSales';
export const STREAMLINE_B2B_BUYING = 'streamlineB2BBuying';
export const GROW_YOUR_REVENUE = 'growYourRevenue'; // Service Biz Objectives

export const TRACK_CUSTOMER_COMMS = 'organizeAndTrackCustomerCommunications';
export const MAXIMIZE_PRODUCTIVITY = 'maximizeProductivity';
export const DELIGHT_CUSTOMERS = 'delightCustomersAtScale';
export const HELP_CUSTOMERS_HELP_THEMSELVES = 'helpCustomersHelpThemselves';
export const MEASURE_IMPROVE_CUSTOMER_EXPERIENCE = 'measureImproveCustomerExperience';
export const DELIVER_EXCEPTIONAL_SERVICE = 'deliverExceptionalService';
export const MANAGE_MULTIPLE_TEAMS = 'manageMultipleTeamsAndBusinesses';
export const OPERATE_WITH_EASE_SERVICE = 'operateWithEaseService';
export const REMOVE_BRANDING_SERVICE = 'removeBrandingService';
export const REMOVE_BRANDING_SERVICE_MON607 = 'removeBrandingServiceMON607';
export const ORGANIZE_SUPPORT_CHANNELS = 'organizeSupportChannels';
export const ORGANIZE_SUPPORT_CHANNELS_MON607 = 'organizeSupportChannelsMON607';
export const STREAMLINE_CUSTOMER_COMMUNICATIONS = 'streamlineCustomerCommunications';
export const IMPROVE_RETENTION = 'improveRetention';
export const CONNECT_SERVICE_TO_FRONT_OFFICE = 'connectServiceToFrontOffice';
export const SCALE_SUPPORT = 'scaleSupport';
export const SCALE_SUPPORT_MON607 = 'scaleSupportMON607';
export const EXPAND_CUSTOMER_RELATIONSHIPS = 'expandCustomerRelationships';
export const EXPAND_CUSTOMER_RELATIONSHIPS_MON607 = 'expandCustomerRelationshipsMON607';
export const MANAGE_SCALING_TEAMS = 'manageScalingTeams';
export const MANAGE_SCALING_TEAMS_MON607 = 'manageScalingTeamsMON607';
export const CUSTOMIZE_YOUR_PROCESS = 'customizeYourProcess';
export const CUSTOMIZE_YOUR_PROCESS_MON607 = 'customizeYourProcessMON607';
export const OPTIMIZE_PERFORMANCE = 'optimizePerformance';
export const OPTIMIZE_PERFORMANCE_MON607 = 'optimizePerformanceMON607'; // CMS Hub Biz Objectives

export const SECURE_YOUR_WEBSITE = 'secureYourWebsite';
export const SECURE_YOUR_WEBSITE_MON607 = 'secureYourWebsiteMON607';
export const BUILD_EFFICIENTLY = 'buildEfficiently';
export const BUILD_EFFICIENTLY_MON607 = 'buildEfficientlyMON607';
export const LEVERAGE_FULL_PLATFORM = 'leverageFullPlatform';
export const PERSONALIZE_CUSTOMER_EXPERIENCES = 'personalizeCustomerExperiences';
export const PERSONALIZE_CUSTOMER_EXPERIENCES_MON607 = 'personalizeCustomerExperiencesMON607';
export const OPTIMIZE_YOUR_WEBSITE = 'optimizeYourWebsite';
export const OPTIMIZE_YOUR_WEBSITE_MON607 = 'optimizeYourWebsiteMON607';
export const EXPAND_CONTENT_STRATEGY = 'expandContentStrategy';
export const EXPAND_CONTENT_STRATEGY_MON607 = 'expandContentStrategyMON607';
export const BUILD_POWERFUL_DIGITAL_EXPERIENCES = 'buildPowerfulDigitalExperiences';
export const BUILD_POWERFUL_DIGITAL_EXPERIENCES_MON607 = 'buildPowerfulDigitalExperiencesMON607';
export const MANAGE_GROWING_TEAM_AND_BRAND = 'manageGrowingTeamAndBrand';
export const EXTEND_DIGITAL_PRESENCE = 'extendDigitalPresence';
export const EXTEND_DIGITAL_PRESENCE_MON607 = 'extendDigitalPresenceMON607';
export const BUILD_REMARKABLE_WEB_PAGES = 'buildRemarkableWebPages';
export const GROW_TRAFFIC_CONVERT_LEADS = 'growTrafficConvertLeads';
export const SECURE_YOUR_WEBSITE_OLD = 'secureYourWebsite';
export const BUILD_POWERFUL_WEB_EXPERIENCES = 'buildPowerfulWebExperiences';
export const GOVERNANCE_AT_SCALE = 'governanceAtScale';
export const EXTEND_YOUR_BRAND = 'extendYourBrand'; // Operations Hub Biz Objectives

export const TRANSFER_DATA_FAST_MON607 = 'transferDataFastMON607';
export const CONNECT_THIRD_PARTY_APPS_MON607 = 'connectThirdPartyAppsMON607';
export const TRACK_EMAIL_EFFORTS_MON607 = 'trackEmailEffortsMON607';
export const CONNECT_TOOLS_AND_SYNC_CUSTOMER_DATA = 'connectToolsAndSyncCustomerData';
export const CONNECT_TOOLS_AND_SYNC_CUSTOMER_DATA_MON607 = 'connectToolsAndSyncCustomerDataMON607';
export const ORGANIZE_YOUR_OPERATIONS_PROCESS_MON607 = 'organizeYourOperationsProcessMON607';
export const AUTOMATE_BUSINESS_PROCESSES = 'automateBusinessProcesses';
export const AUTOMATE_BUSINESS_PROCESSES_MON607 = 'automateBusinessProcessesMON607';
export const CLEAN_CUSTOMER_DATA = 'cleanCustomerData';
export const CLEAN_CUSTOMER_DATA_MON607 = 'cleanCustomerDataMON607';
export const MONITOR_AND_CLEAN_DATA = 'monitorAndCleanData';
export const MANAGE_SCALING_BUSINESS = 'manageScalingBusiness';
export const OPERATIONS_BUILD_CUSTOM_REPORTS = 'operationsBuildCustomReports';
export const OPERATIONS_BUILD_CUSTOM_REPORTS_MON607 = 'operationsBuildCustomReportsMON607';
export const ORGANIZE_YOUR_OPERATIONS_EFFORTS = 'organizeYourOperationsEfforts';
export const CURATE_AND_MANAGE_DATA_WITH_EASE = 'curateAndManageDataWithEase';
export const CUSTOMIZE_AND_EXTEND_THE_PLATFORM = 'customizeAndExtendThePlatform'; // Mon333 biz objectives

export const CONVERT_AND_NURTURE_LEADS = 'convertAndNurtureLeads';
export const MEASURE_REVENUE = 'measureRevenue';
export const ORGANIZE_YOUR_TEAM = 'organizeYourTeam';
export const STREAMLINE_YOUR_OUTREACH = 'streamlineYourOutreach';
export const HELP_AND_DELIGHT_CUSTOMERS = 'helpAndDelightCustomers';
export const CREATE_REMARKABLE_WEBSITES = 'createRemarkableWebsites';
export const CUSTOMIZE_USING_TOOLS = 'customizeUsingTools';
export const GET_SPEED_RELIABILITY_SECURITY = 'getSpeedSecurityReliability';
export const GET_HELP_FAST = 'getHelpFast';
export const GET_HELP_FAST_MON607 = 'getHelpFastMON607';
export const ADVANCED_SUPPORT = 'advancedSupport';
export const ADVANCED_SUPPORT_MON607 = 'advancedSupportMON607'; // Ideally we shouldn't export this, but some place might still import this the wrong way

export default {
  // CMS Biz Objectives
  PERSONALIZE_EXPERIENCES,
  CAPTURE_CONVERT_LEADS_CMS,
  // Marketing Biz Objectives
  ATTRACT_AUDIENCE_ATTENTION,
  UNDERSTAND_LEADS,
  AUTOMATE_MARKETING,
  GET_FOUND_ONLINE_MARKETING,
  OPTIMIZE_CONVERSION,
  BUILD_CUSTOM_REPORTS,
  MANAGE_TEAMS_AND_BRANDS,
  EXTEND_PLATFORM,
  ADVANCE_YOUR_REPORTING,
  REMOVE_BRANDING_MARKETING,
  MARKETING_AUTOMATION,
  // Sales Biz Objectives
  ORGANIZE_YOUR_SALES_PROCESS,
  CONNECT_WITH_PROSPECTS,
  TRACK_ITERATE_IMPROVE,
  PERSONALIZE_OUTREACH,
  COACH_AND_ENABLE,
  MANAGE_GROWING_TEAM,
  CONFIGURE_PRICE_QUOTE,
  SCALE_YOUR_BUSINESS,
  SUPERCHARGE_YOUR_PIPELINE,
  CUSTOMIZE_TO_MATCH_YOUR_BUSINESS,
  EXTEND_ADMINISTRATIVE_CONTROLS,
  OPERATE_WITH_EASE_SALES,
  REMOVE_BRANDING_SALES,
  // Service Biz Objectives
  TRACK_CUSTOMER_COMMS,
  MAXIMIZE_PRODUCTIVITY,
  DELIGHT_CUSTOMERS,
  HELP_CUSTOMERS_HELP_THEMSELVES,
  MEASURE_IMPROVE_CUSTOMER_EXPERIENCE,
  DELIVER_EXCEPTIONAL_SERVICE,
  MANAGE_MULTIPLE_TEAMS,
  OPERATE_WITH_EASE_SERVICE,
  REMOVE_BRANDING_SERVICE,
  ORGANIZE_SUPPORT_CHANNELS,
  STREAMLINE_CUSTOMER_COMMUNICATIONS,
  IMPROVE_RETENTION,
  CONNECT_SERVICE_TO_FRONT_OFFICE,
  SCALE_SUPPORT,
  EXPAND_CUSTOMER_RELATIONSHIPS,
  MANAGE_SCALING_TEAMS,
  CUSTOMIZE_YOUR_PROCESS,
  OPTIMIZE_PERFORMANCE,
  // CMS Hub Biz Objectives
  BUILD_EFFICIENTLY,
  LEVERAGE_FULL_PLATFORM,
  PERSONALIZE_CUSTOMER_EXPERIENCES,
  OPTIMIZE_YOUR_WEBSITE,
  EXPAND_CONTENT_STRATEGY,
  BUILD_POWERFUL_DIGITAL_EXPERIENCES,
  MANAGE_GROWING_TEAM_AND_BRAND,
  EXTEND_DIGITAL_PRESENCE,
  BUILD_REMARKABLE_WEB_PAGES,
  GROW_TRAFFIC_CONVERT_LEADS,
  SECURE_YOUR_WEBSITE,
  SECURE_YOUR_WEBSITE_OLD,
  BUILD_POWERFUL_WEB_EXPERIENCES,
  GOVERNANCE_AT_SCALE,
  EXTEND_YOUR_BRAND,
  // Operations Hub Biz Objectives
  CONNECT_TOOLS_AND_SYNC_CUSTOMER_DATA,
  AUTOMATE_BUSINESS_PROCESSES,
  CLEAN_CUSTOMER_DATA,
  MANAGE_SCALING_BUSINESS,
  OPERATIONS_BUILD_CUSTOM_REPORTS,
  // Mon333 biz objectives
  CONVERT_AND_NURTURE_LEADS,
  MEASURE_REVENUE,
  ORGANIZE_YOUR_TEAM,
  STREAMLINE_YOUR_OUTREACH,
  HELP_AND_DELIGHT_CUSTOMERS,
  CREATE_REMARKABLE_WEBSITES,
  CUSTOMIZE_USING_TOOLS,
  GET_SPEED_RELIABILITY_SECURITY,
  GET_HELP_FAST,
  ADVANCED_SUPPORT,
  BUILD_CUSTOM_REPORTS_MON607,
  MANAGE_TEAMS_AND_BRANDS_MON607,
  EXTEND_PLATFORM_MON607,
  ADVANCE_YOUR_REPORTING_MON607,
  AUTOMATE_AND_PERSONALIZE_ENGAGEMENT_MON607,
  ORCHESTRATE_EFFICIENT_CAMPAIGNS_MON607,
  REMOVE_BRANDING_MARKETING_MON607,
  ORGANIZE_YOUR_SALES_PROCESS_MON607,
  PERSONALIZE_OUTREACH_MON607,
  COACH_AND_ENABLE_MON607,
  MANAGE_GROWING_TEAM_MON607,
  CONFIGURE_PRICE_QUOTE_MON607,
  CUSTOMIZE_TO_MATCH_YOUR_BUSINESS_MON607,
  EXTEND_ADMINISTRATIVE_CONTROLS_MON607,
  OPERATE_WITH_EASE_SALES_MON607,
  REMOVE_BRANDING_SERVICE_MON607,
  ORGANIZE_SUPPORT_CHANNELS_MON607,
  SCALE_SUPPORT_MON607,
  EXPAND_CUSTOMER_RELATIONSHIPS_MON607,
  MANAGE_SCALING_TEAMS_MON607,
  CUSTOMIZE_YOUR_PROCESS_MON607,
  OPTIMIZE_PERFORMANCE_MON607,
  SECURE_YOUR_WEBSITE_MON607,
  BUILD_EFFICIENTLY_MON607,
  PERSONALIZE_CUSTOMER_EXPERIENCES_MON607,
  OPTIMIZE_YOUR_WEBSITE_MON607,
  EXPAND_CONTENT_STRATEGY_MON607,
  BUILD_POWERFUL_DIGITAL_EXPERIENCES_MON607,
  EXTEND_DIGITAL_PRESENCE_MON607,
  TRANSFER_DATA_FAST_MON607,
  CONNECT_THIRD_PARTY_APPS_MON607,
  TRACK_EMAIL_EFFORTS_MON607,
  ORGANIZE_YOUR_OPERATIONS_PROCESS_MON607,
  CLEAN_CUSTOMER_DATA_MON607,
  OPERATIONS_BUILD_CUSTOM_REPORTS_MON607,
  GET_HELP_FAST_MON607,
  ADVANCED_SUPPORT_MON607
};